import { Event } from "../contracts";
import { ScoreboardProps } from "../blocks/EventListPresenter/components";
import { additionalScoreWeight, sortHelper } from "../helpers";

const ScoreboardPropsFunction = (x: Event): ScoreboardProps => {
    const team1 = "1";
    const team2 = "2";

    const filterTeam = (position: string) => {
        return Object.keys(x.score.additionalScores)
            .filter(scoreKey => scoreKey[scoreKey.length - 1] === position)
            .filter(x => Object.keys(additionalScoreWeight).some(y => x.toLowerCase().indexOf(y) > -1))
            .filter(scoreKey => {
                const oppositePos = position === team1 ? team2 : team1;
                const scoreKeyOpposite = `${scoreKey.slice(0, scoreKey.length - 1)}${oppositePos}`;

                return x.score.additionalScores[scoreKey] !== "0" || x.score.additionalScores[scoreKeyOpposite] !== "0";
            })
            .sort((x, y) => sortHelper(x) - sortHelper(y))
            .map(value => x.score.additionalScores[value]);
    };

    const props = (first: string, second: string): ScoreboardProps => {
        return {
            team1: filterTeam(first),
            team2: filterTeam(second),
            endingPoint1: x.score.additionalScores[`currentGameScore${first}`],
            endingPoint2: x.score.additionalScores[`currentGameScore${second}`]
        };
    };

    if (x.isTeamSwap) {
        return props(team2, team1);
    }

    return props(team1, team2);
};

export const Scoreboards = {
    Tennis: ScoreboardPropsFunction,
    Volleyball: ScoreboardPropsFunction,
    BeachVolleyball: ScoreboardPropsFunction,
    Empty: (): ScoreboardProps => {
        return {
            team1: [],
            team2: [],
            endingPoint1: "",
            endingPoint2: ""
        };
    }
};